import React from 'react';
import styles from './styles/CalendarEvent.module.css';
import legendStyles from './styles/CalendarLegend.module.css';
import { STATUS_ICONS } from './CalendarEventContent';
import { CLASSROOM_PALETTE, EVENT_STATUS, STATUS_LABELS } from './calendarUtils';

const SAMPLE_COLOR = CLASSROOM_PALETTE[0];

const ENTRIES = [
    { status: EVENT_STATUS.UPCOMING, role: 'student', text: 'Due soon, not started' },
    { status: EVENT_STATUS.IN_PROGRESS, role: 'student', text: 'Started' },
    { status: EVENT_STATUS.COMPLETED, role: 'student', text: 'Finished' },
    { status: EVENT_STATUS.LATE, role: 'student', text: 'Past due, not started' },
    { status: EVENT_STATUS.NO_DUE_DATE, role: 'student', text: 'No due date — shown on the day it was assigned' },
    { status: EVENT_STATUS.TEACHER, role: 'teacher', text: 'An assignment in a classroom you teach' },
];

/** Explains the event styles. Each sample is drawn with the same classes as a real event. */
const CalendarLegend = () => (
    <details className={legendStyles.legend}>
        <summary className={legendStyles.summary}>Legend</summary>
        <ul className={legendStyles.list}>
            {ENTRIES.map(({ status, role, text }) => {
                const Icon = STATUS_ICONS[status];
                return (
                    <li key={status} className={legendStyles.item}>
                        <span
                            className={`${styles.event} ${styles[role]} ${styles[status]} ${legendStyles.sample}`}
                            style={{ '--classroom-color': SAMPLE_COLOR }}
                        >
                            <span className={styles.swatch} aria-hidden="true" />
                            <Icon className={styles.icon} aria-hidden="true" />
                            <span className={styles.title}>{STATUS_LABELS[status]}</span>
                        </span>
                        <span className={legendStyles.text}>{text}</span>
                    </li>
                );
            })}
            <li className={legendStyles.item}>
                <span className={legendStyles.paletteSample} aria-hidden="true">
                    {CLASSROOM_PALETTE.slice(0, 4).map((color) => (
                        <span key={color} style={{ background: color }} />
                    ))}
                </span>
                <span className={legendStyles.text}>Each classroom has its own colour, matching its filter chip</span>
            </li>
        </ul>
    </details>
);

export default CalendarLegend;
